import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';

import './utils/meta.utils.js';

// import './components/bold-loader.component.js';
import './components/bold-loader-new.component.js';
import './components/mouse.component.js';
import './components/footer.component.js';
import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/meta-select.component.js';

import './components/animations.component.js';
// import './components/granim.component.js';
import './components/buttons.component.js';
import './components/player.component.js';

import './components/evolve.component.js';
import './components/be-bold.component.js';
import './components/faqs.component.js';
import './components/first-rows.component.js';
import './components/text-sec-rows.component.js';
import './components/tech-rows.component.js';
import './components/project.component.js';
import './components/testimonials.component.js';
import './components/latest-works.component.js';
import './components/project-dropdown.component.js';
import './components/chat.component.js';

/*Sliders*/
import './components/sw-works.component.js';
import './components/sw-integrations-content.component.js';
import './components/sw-latest-works.component.js';
import './components/drag-slider.component.js';
import './components/clients-marqee.component.js';
import './components/highlights-marqee.component.js';
import './components/trustpilot-reviews-marqee.component.js';
import './components/trustpilot-reviews.component.js';
import './components/what-we-do.component.js';
import './components/sw-expertise-mobile.component.js';
import './components/expertise.component.js';
import './components/case-studies-head.component.js';
import './components/case-studies.component.js';
import './components/integrations.component.js';
/*Sliders End*/

import './components/overlayScroll.component.js';

/*Animations*/
import './components/animations/first-gradient-animation.component.js';
import './components/animations/orbital-gradient.component.js';
import './components/animations/footer-gradient-animation.component.js';
import './components/animations/latest-works-gradient-animation.component.js';
import './components/animations/project-gradient-animation.component.js';
import './components/animations/blur-text-animation.component.js';
import './components/animations/text-digital-fill-animation.component.js';
import './components/animations/bg-change-animation.component.js';
import './components/animations/bg-first-parallax-animation.component.js';
import './components/animations/bg-parallax-animation.component.js';
import './components/portfolio-flipbook.component.js';
import './components/animations/text-sec-arrow-animation.component.js';
import './components/animations/text-parallax-animation.component.js';
import './components/animations/highlights-aura-animation.component.js';
import './components/animations/bg-aura-animation.component.js';
import './components/animations/image-scale-animation.component.js';
import './components/animations/card-scale-animation.component.js';
import './components/animations/parallax-vertical-animation.component.js';
import './components/animations/parallax-mob-vertical-animation.component.js';
import './components/animations/header-hidden-animation.component.js';
import './components/animations/text-sticky-animation.component.js';
import './components/animations/first-images-animation.component.js';
import './components/animations/floema-floating-hero-animation.component.js';
import './components/animations/first-drag-animation.component.js';

import './components/tabs.component.js';
import './components/validation.component.js';
import './components/video-popup.component.js';

import './libs/countUp.lib.js';

(() => {
  const firstHomeButtons = document.querySelector(
    '.first-sec.home-first-sec .first-sec__buttons'
  );
  const btnToTop = document.querySelector('.btn-to-top');
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  if (isChrome && window.innerWidth >= 1025) {
    if (firstHomeButtons) {
      firstHomeButtons.classList.add('is-chrome');
    }

    if (btnToTop) {
      btnToTop.classList.add('is-chrome');
    }
  }
})();

window.jsScrollToEl = function jsScrollToEl(targetID) {
  let config = targetID.split('|');
  let duration = +config[1] && +config[1] !== '' ? +config[1] : 800;
  let paddingTop = +config[2] && +config[2] !== '' ? +config[2] : 0;
  let target = config[0];
  let targetElement = document.querySelector(target);

  if (targetElement) {
    let targetOffsetTop = targetElement.offsetTop - paddingTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth',
    });
    return false;
  }
};

(function detectSafari() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.body.classList.add('is-safari');
  }
})();

function setUrlParams(paramName, value = 1) {
  window.history.replaceState(null, null, `?${paramName}=${value}`);
}

window.setUrlParams = setUrlParams;

function removeUrlParams() {
  const url = new URL(window.location.href);

  url.search = '';

  window.history.replaceState({}, document.title, url.href);
}

window.removeUrlParams = removeUrlParams;

window.addEventListener('load', () => {
  const regex = /showreel=1/;
  const url = new URL(window.location.href);

  if (regex.test(url.search)) {
    window.openVideo('hero-video');
  }
});
